<template>
    <div class="container">
        <div class="top">
            <div class="bannerBox">
                <img :src="productInfo.photo_l" class="banner" v-lazy="productInfo.photo_l" alt="">
            </div>
            <div class="info">
                <div class="title">{{productInfo.name}}</div>
                <div class="subTitle">{{productInfo.intro}}</div>
                <div class="red ">￥ <span class="price">{{price}}</span> 起</div>
            </div>
           
        </div>
        <div class="top pintroc">
             <div>
                <van-cell>
                    <template #icon>
                        <span>产品特点</span>
                    </template>
                    <template #title>
                        <span>{{productInfo.goods_trait}}</span>
                    </template>
                </van-cell>
                <van-cell border>
                    <template #icon>
                        <span>产品方案</span>
                    </template>
                    <template #title>
                        <span v-for="(item,index) of productInfo.goods_plan" :key="index">
                            <van-tag  round @click="checked(index)" :plain="checkVal!=index">{{item}}</van-tag>
                        </span>
                    </template>
                </van-cell>
                <van-cell title="趸交">
                    <template #icon>
                        <span>保障期限</span>
                    </template>
                </van-cell>
                <!-- <my-select title="保障期限" :columns="columns1" :index="2"></my-select> -->
                <my-select title="有无社保" :columns="columns2" :index="0"></my-select>
                <!-- <my-select title="承保年龄" :columns="columns3" :index="2"></my-select> -->
                <van-cell border :title="productInfo.company_str">
                    <template #icon>
                        <span>承保公司</span>
                    </template>
                </van-cell>
            </div>
        </div>
        <!-- 详情 -->
        <div class="details">
            <van-index-bar :index-list="indexList" :sticky-offset-top="offsetTop" @select="select" :z-index="zIndex">
                <van-index-anchor class="anchor" :index="indexList[0]"/>
                <line-title :title="indexList[0]"></line-title>
                <div v-for="(item,index) of productInfo.photos" :key="index">
                    <img :src="item" style="width:100%"  alt="">
                </div>
                <van-index-anchor class="anchor" :index="indexList[1]"/>
                <line-title :title="indexList[1]"></line-title>
                <div v-html="productInfo.content" class="imgsedit"></div>
                <van-index-anchor class="anchor" :index="indexList[2]"/>
                <line-title :title="indexList[2]"></line-title>
                <div>
                    <img :src="this.common.service_agree" style="width:100%"  alt="">
                </div>
                <van-index-anchor class="anchor" :index="indexList[3]"/>
                <line-title :title="indexList[3]"></line-title>
                <div>
                    <img :src="this.common.claims_process" style="width:100%"  alt="">
                </div>
            </van-index-bar>
        </div>
        <div class="bgBlueH"></div>
        <!-- 收藏/分享 -->
        <van-goods-action v-if="productInfo.is_report=='1'" class="btl">
            <van-goods-action-icon :text="productInfo.is_fav=='1'?'已收藏':'收藏'"  @click="collect()" >
                <template #icon>
                    <img v-if="productInfo.is_fav=='1'" class="icons2" src="@/assets/icons/shoucang2.png" alt="已收藏">
                    <img v-else class="icons2" src="@/assets/icons/shoucang1.png" alt="收藏">
                </template>
            </van-goods-action-icon>
            <van-goods-action-icon text="分享" @click="showShare=true">
                <template #icon>
                    <img class="icons" src="@/assets/icons/fenxiang.png" alt="">
                </template>
            </van-goods-action-icon>
            <van-goods-action-button class="limitBtn" type="danger" text="立即投保" @click="handleClick()"/>
        </van-goods-action>
        <van-goods-action v-else>
            <van-goods-action-button class='wbtn' type="danger" text="备案中" @click="handleClick()"/>
        </van-goods-action>
        <share :showShare='showShare' :info="productInfo" :shareBaseUrl="shareBaseUrl" @isShowShare="isShowShare()"></share>
    </div>
</template>

<script>
import share from '@/components/share'
import mySelect from '@/components/select'
import lineTitle from "@/components/lineTitle"
import { Toast } from 'vant'
import { mapState } from 'vuex'
import {wxShare} from '@/utils/share'
import {wxLogin} from '@/utils/util'
export default {
    data() {
        return {
            id:"",//当前商品id
            productInfo:'',
            images:[],
            isshow:false,  //true:已收藏，false：未收藏
            showShare: false,
            // selectShow:false,
            checkVal:0,
            columns1:['21-25天', '26-30天', '31-60天', '61-90天', '91-180天'],
            columns2:['有','无'],
            columns3:['21-25', '26-30', '31-35', '36-40', '41-45'],
            // 详情 索引相关数据
            offsetTop:60,
            indexList: ["产品介绍", "投保须知", "服务约定", "理赔流程"],
            height:'500',//索引内容区域距离顶部的高度
            zIndex:"-1",

        };
    },
    created(){
        this.id=this.$route.query.id;
        this.getDetails(this.id);
        if(!this.$store.state.CommonInfo){
            this.getCommonInfo();
        }
        this.shareClick();
    },
    mounted(){
        document.documentElement.scrollTop =0;
        document.body.scrollTop=0;
        setTimeout(()=>{
            let height=document.querySelector(".details").offsetTop;
            this.height=height-60;
        },500)
        window.addEventListener('scroll',this.scrollPosition);
        // console.log("我是详情页",this.shareBaseUrl)
    },
    destroyed() {     //销毁
        window.removeEventListener("scroll",this.scrollPosition);
        wxShare();
    },
    methods: {
        scrollPosition(){
            let scrollTop=document.documentElement.scrollTop || document.body.scrollTop//滚动条滚动时，距离顶部的距离
            if(scrollTop>=this.height && this.zIndex!="1"){
                this.zIndex="1";
                return;
            }else if(scrollTop<this.height && this.zIndex!="-1"){
                this.zIndex="-1";
                return;
            }
        },
        select(e){
            document.body.scrollTop +=1;
            document.documentElement.scrollTop +=1;
            console.log(e,"eeeeeee")
            // if(e=="理赔流程"){
            //     this.offsetTop=0;
            // }else{
            //     this.offsetTop=60;
            // }
        },
        //产品方案切换
        checked(e){
            this.checkVal=e;
        },
        isShowShare(e){
                this.showShare=false;
        },
        //收藏/取消收藏
        collect(){
            if(!this.token){
                this.$store.commit("LOGOUT")
                this.$router.push("/login")
            }else{
                let type;
                if(this.productInfo.is_fav=='1'){//已收藏状态
                    type="delete";
                }else{
                    type="add";
                }
                this.$https.fetchPost("Favorite/"+type,{"id":this.id},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    console.log(result.data);
                    if(result.data.code==1){
                        if(this.productInfo.is_fav=='1'){//已收藏状态
                            this.productInfo.is_fav='0';
                        }else{
                            this.productInfo.is_fav='1'
                        }
                    }else{
                        Toast(result.data.msg)
                    }
                })
            }
        },
        getDetails(id){
            // pjh
            // if(!this.token){
            //     this.$store.commit("LOGOUT")
            //     this.$router.push("/login")
            // }else{
                this.$https.fetchPost("Goods/detail",{"id":id},{headers:{"XX-Token":this.token}})
                .then(result=>{
                    let data=result.data;
                    document.title=data.data.name;
                    console.log(result,"**********")
                    if(data.code==1){
                        this.productInfo=data.data;
                        this.addImgStyle();
                        let info={title:this.productInfo.name,imgUrl:this.productInfo.photo_s,desc:this.productInfo.goods_trait,link:this.shareBaseUrl};
                        wxShare(info);
                    }else if(data.code==10001){  //有token,用户未登陆情况
                        let href=window.location.href;
                        wxLogin(href);
                    }else{
                        Toast(data.msg)
                    }
                })
            // }
            
        },
        addImgStyle(){
            let content=this.productInfo.content;
            content=content.replace(/<img/g,'<img style="width:100%"');
            content=content.replace(/<p style="line-height: 16px;"><img style="width:100%"/g,'<p style="line-height: 16px;"><img')
            this.productInfo.content=content
        },
        // 立即投保
        handleClick(){
            if(this.productInfo.is_report==0){
                Toast("备案中")
            }else{
                window.location.href=this.productInfo.out_insure_url;
            }
        },
        //获取服务约定/理赔流程
        getCommonInfo(){
            this.$https.fetchGet("Goods/publicDetail")
            .then(result=>{
                let res=result.data;
                if(res.code==1){
                    this.$store.commit('SET_COMMONINFO',res.data)
                    console.log("prodeucDetails详情页",this.$store.state.CommonInfo)
                }else{
                    Toast(res.msg)
                }
            })
        },
        //打开页面时，如果地址栏有share_user_id这个参数且本地user_status=1时（普通用户点击）
        shareClick(){
            let params=this.$route.query;
            if(!params.share_user_id){
                return
            }
            // pjh
            // let state=this.$store.state.userInfo.user_type;
            // if(state==2){  //普通用户可以点击
            //     this.shareClickFun(params.share_user_id,params.id)
            // }
            this.shareClickFun(params.share_user_id,params.id)
        },
        shareClickFun(share_uid,goods_id){
            this.$https.fetchPost("Wechat/shareClick",{"share_uid":share_uid,"goods_id":goods_id},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                console.log(result.data);
            })
        }
    },
    components:{
      share,
      mySelect,
      lineTitle
    },
    computed:{
        ...mapState(["CommonInfo","userInfo","token"]),
        common(){
            return this.CommonInfo ? this.CommonInfo : '';
        },
        price(){
            let arr=this.productInfo.price;
            return arr===undefined ? "0" : arr[this.checkVal];
        },
        shareBaseUrl(){
            return window.location.href;
            // if(this.userInfo.user_type==2){  //普通用户pjh
            //     return window.location.href;
            // }else{                           //经纪人   
            //     return window.location.href+'&share_user_id='+this.userInfo.id;//分享的链接，参数应带上经纪人id
            // }
        }
    }
}
</script>

<style scoped>
    /* .container{
        background: #fff;
    } */
    .limitBtn{
        width:220px;
        flex: none;
        margin-left:21px;
    }
    .wbtn{
        width:300px;
        margin:0 auto;
        flex: none;
        font-size:16px;
    }
    .top{
        padding: 15px 22px 16px 22px;
    }
    .pintroc{
        padding: 0 15px;
        border-top:10px solid #f5f5f5;
    }
    
    .banner{
        width: 100%;
        max-height: 331px;
    }
    .imgsedit{
        text-align: left;
        padding:0 23px 11px 23px;
    }
    
   .info{
       text-align: start;
   }
   .info>.title{
       color:#333;
       font-size: 16px;
       font-weight: bold;
       margin-top:10px;
       margin-bottom:3px;
   }
   .info>.subTitle{
       font-size: 12px;
       color: #666;
       margin-bottom:16px;
   }
   .info .red{
       font-size:11px;
        letter-spacing: 0px;
   }
   .info .price{
        font-size: 20px;
        font-weight: 700;
    }
    #selectContent{
         border-bottom:1PX solid #ebebeb;
    }
    .pintroc .van-cell{
        padding-left: 0;
        padding-right: 0;
        border-bottom:1PX solid #ebebeb;
         color:#666;
        font-size:14px;
        align-items: center;
    }
    .pintroc .van-cell__title {
        text-align: right;
        margin-left: 20px;
        color:#333;
        font-size:14px;
    } 
    .pintroc .van-cell__title>span{
        margin:0 5px;
    }
    .pintroc .van-cell__title>span:nth-of-type(4n+0){
        margin-right:0;
    }
    .pintroc .van-tag{
        width:60px;
        height:28px;
        font-size:14px;
        color:#fff;
        justify-content: center;
        background: linear-gradient(to right,#f34740,#fb958a);
        border:none;
        margin-bottom: 5px;
        
    }
    
    .pintroc .van-tag--plain{
        color:#333;
        background:none;
        background-color:#fff;
    }
    .pintroc .van-tag::after{
        border-color:none;
    }
    .pintroc .van-tag--plain::after{
        border-color:#333;
    }
    .bgBlueH{
        width: 100%;   
        height: 60px;
    }
    .van-goods-action-button--danger{
        background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1));
    }
    .details{
        font-size:14px;
        border-top:10px solid #f5f5f5;
        background-color: #fff;
    }
    /* 索引相关样式 */
        .details /deep/ .van-index-bar__sidebar{
        top: 0;
        transform: translateY(0);
        left: 0;
        right: 0;
        flex-direction: row;
        justify-content: space-between;
        background: #fff;
    }
    .details /deep/ .van-index-bar__index{
        height: 50px;
        line-height: 50px;
        flex: auto;
        padding: 0;
        font-size:14px;
    }

    .details /deep/ .van-index-bar__index--active{
        background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1));
        color: #fff;
    }
    .details /deep/ .van-index-anchor--sticky,.details /deep/ .van-index-anchor{
        opacity: 0; 
        /* height: 0 !important; */
    } 
    .anchor{
        height: 0px !important;
    }
    .icons{
        width: 16px;
        height: 16px;
    }
    .icons2{
        width: 19px;
        height: 19px;
    }
    .van-goods-action-icon{
        color: #666;
        width:55px;
    }
    .btl{
        padding-left:11px;
    }
</style>
<style lang="">
    .imgsedit p{
        margin:0;
        margin-bottom: 6px;
    }
    .imgsedit a{
        color:#D3241D!important;
        font-size:12px!important;
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/commonPage/productDetails.vue